var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rectangle",class:[
    { 
      colorfull: _vm.colorFull, 
      roundedd: _vm.rounded, 
      'no-border': _vm.noBorder, 
      magnify: _vm.magnify, 
      'no-shadow': _vm.noShadow ,
      'dark-text': _vm.darkText,
    },
     _vm.bgColor]},[(_vm.icon)?_c('i',{staticClass:"mr-2",class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }